var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"deploy-date"},[_vm._v(" "+_vm._s(_vm.$t("vdcontainer.deploy_date_tip",{"date":_vm.formatdate(_vm._item.expectOpenTime)}))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }